export const INF_RESULT_FIELD_LABELS = {
  homogenized_mean: 'Valor Unitário Médio',
  lower_limit: 'Valor Unitário Mínimo',
  upper_limit: 'Valor Unitário Máximo',
  market_value: 'Valor Total Médio',
  lower_limit_total: 'Valor Total Mínimo',
  upper_limit_total: 'Valor Total Máximo',
  lower_limit_confidence: 'Amplitude Mínima do Modelo',
  upper_limit_confidence: 'Amplitude Máximo do Modelo',
  rounded_market_value: 'Valor de Mercado Arredondado',
  report_date: 'Data de Referência',
} as const;

export const INF_STATISTIC_FIELD_LABELS = {
  r: 'Coeficiente de Correlação',
  rsquared: 'Coeficiente de Determinação',
  f_fisher: 'Fisher - Snedecor',
  model_significance_pct: 'Significância do Modelo',
  residuals_curve_normal: 'Curva Normal',
  residuals_model: 'Modelo',
  total_variables: 'Total de Variáveis',
  model_total_variables: 'Variáveis Utilizadas no Modelo',
  all_data_count: 'Total de Dados',
  model_data_count: 'Dados Utilizados no Modelo',
  outliers_quantity: 'Quantidade de Outliers',
  outliers_percentage: 'Porcentagem de Outliers',
  sum_of_squares: 'Soma dos Quadrados',
  degrees_of_freedom: 'Graus de Liberdade',
  squares_mean: 'Quadrado Médio',
  variance_f: 'F',
  hypothesis_variable: 'Variável',
  hypothesis_transformation: 'Transformação',
  hypothesis_t_obs: 'T Obs',
  hypothesis_significance: 'Significância (%)',
  variable_type: 'Tipo da Variável',
  variable_description: 'Descrição',
  variable_name: 'Nome',
  variable_unit: 'Unidade',
  equation: 'Equação de Regressão',
} as const;

export const INF_GRAPHS_FIELD_LABELS = {
  adherence: 'Gráfico de Aderência - Regressão linear',
  residuals: 'Gráfico de Resíduos - Regressão linear',
  reducedNormalCurve: 'Gráfico de Aderência à Curva Normal Reduzida',
  cooksDistance: 'Distância de Cook',
  totalValue: 'Valor Total',
} as const;

export const INFERENCES_TABS = [
  { key: 'result', label: 'Resultado da avaliação e data de referência' },
  { key: 'statistics', label: 'Resultados estatísticos' },
  { key: 'foundation', label: 'Fundamentação' },
  { key: 'graphs', label: 'Análise Gráfica' },
] as const;
